module.exports = __webpack_public_path__ + "img/slide2.d7627d34.png";